/* eslint-disable no-unused-vars */
// import Socket from "src/utils/Socket.io";
import React from 'react';

import { toast } from 'react-toastify';
// import * as icons from ''
import { Link } from "react-router-dom";
// import { renderIcon } from "src/utils/functions/core"
import { notification, message, Tooltip } from 'antd';
import { querySelectValidation } from "src/utils/functions/queryFetch"
import { allinPut, allinOne } from "./queryFunction"
import { getFetch } from "src/utils/functions/queryRoute"
// const queryFetch = require("src/utils/functions/queryFetch");
// const _Socket = new Socket()
import { socket } from "src/utils/socket";
// import { FaBeer } from "react-icons-ng/fa";
// const _icons = React.lazy(() => import('react-icons-ng/all'));
// const icons = _icons?.default
// const objIcons = {}
// const _icons = Object.keys(icons)
// console.log(_icons)
// import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import * as icons from '@ant-design/icons';
// import loadable from '@loadable/component'
// const _icons = loadable(() => import('@ant-design/icons'))
// const HomeOutlined = React.lazy(() => import('@ant-design/icons/HomeOutlined'));
// const ExclamationCircleOutlined = React.lazy(() => import('@ant-design/icons/ExclamationCircleOutlined'));

// const _icons = React.lazy(() =>
//   import("@ant-design/icons").then(module => {
//     // console.log(module)
//     return { default: module.Viewer };
//   })
// );
const endPoint = window.origin

// let count = 1

const protectedRoute = (e) => {
  const { user } = content()
  if (e?.id === user?._id) {
    return true
  } else {
    return false
  }
}

const localStor = (item) => {
  if (localStorage.getItem(item)) {
    return JSON.parse(localStorage.getItem(item))
  } else return false
}

// const socket = () => {
//   if (count === 1) {
//     const { user } = content()
//     console.log(count++)
//     _Socket.connect(endPoint, user._id)
//     // _Socket.on("socketInfo", (el) => { localStorage.setItem("socketInfo", JSON.stringify(el)) })
//     // _Socket.on(auth_token, (data) => { logout() })
//
//   }
//   return _Socket
// }

// const socket = (e) => {
//   const { user } = content()
//
//   if (content()) {
//     // _Socket.connect(endPoint, user._id)
//     // return _Socket
//   }else {
//     // _Socket.disconnect()
//   }
//
//
//   // if (!e) {
//   //   console.log("disconnect")
//   //   _Socket.disconnect()
//   // }
//   // if (content()) {
//   //   console.log("connect")
//   // }
// }

const _logout = (navigate) => {
  // console.log(navigate)
  // console.log(socket)
  const { user, token } = content()
  const { data } = isLocal("statusUsers") ?? ""
  // console.log(content())
  // setIsLoading(true)
  // console.log(user, data)
  // socket.connect()
  socket.emit("logout", {
    userId: user?._id,
    token: token,
    socketId: data?.socketId
  })
  // socket.off('statusUsers');
  // socket.disconnect();
  notification.destroy()
  message.destroy()
  localStorage.clear()
  if (navigate) {
    navigate({ pathname: '/' })
  }
  window.location.reload()
  // setTimeout(() => {
  //   notification.destroy()
  //   message.destroy()
  //   localStorage.clear()
  //   // navigate ? navigate({ pathname: '/home' }) : window.location.reload()
  //   navigate({ pathname: '/home' })
  //   window.location.reload()
  //   // if (navigate) {
  //   //   navigate({ pathname: '/home', isAuthenticated: false })
  //   // }else {
  //   // }
  //   // history.push({ pathname: '/login', isAuthenticated: false })
  // }, 2000)
}

// const renderIcons = (b) => {
//   console.log(b)
//   // const Component = icons[icons[icon] ? icon : "MdOutlineDisabledByDefault"]
//   // return <Component style={{ color: color, fontSize: size }} />
// }

const langPrepare = (langPrefix, languages) => {
  let arr = []
  if (langPrefix && langPrefix.length > 0) {
    langPrefix.forEach((el, i) => {
      arr.push({
        ...languages[el],
        code: el
      })
    })
  }
  return arr
}

const _6cb5f3ef1836479e88189b97b5fe659f = (obj) => {
  return btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
};
const _2d49143faabb48f7b1e9f9de12fbce23 = (_) => {
  if (!_) return;
  return JSON.parse(decodeURIComponent(escape(atob(_))));
};
const content = () => {
  const body = localStorage.getItem("body")
  if (!body) return {}
  const _ = _2d49143faabb48f7b1e9f9de12fbce23(body);
  return _
}

const findTimePicker = (pages, key) => {
  // const findPage = pages.find((f) => f.route === key)
  // const getPremisson = pages.options.timeRangePicker.find((f) => f === findPage._id)
  // if (getPremisson) {
  //   return true
  // }else {
  //   return false
  // }
}

const destructUrl = (url) => {
  return Object.fromEntries(new URLSearchParams(url))
}


const isLocal = (type) => {
  const _type = localStorage.getItem(type)
  const decodedData = _2d49143faabb48f7b1e9f9de12fbce23(localStorage.getItem(type));
  // console.log(decodedData);
  try {
    return decodedData
  } catch (e) {
    return false
  } finally {
  }
}

const urlString = (obj) => {
  return new URLSearchParams([
    ...Object.entries(obj),
  ]).toString();
}


const setLocal = (type, value) => {
  // const storedUser = ls.get("userData");
  if (value) {
    const encodedData = _6cb5f3ef1836479e88189b97b5fe659f(value);
    // console.log(encodedData)
    localStorage.setItem(type, encodedData)
  }
}

// NOTE: for update BODY
const updateContentLocal = (key, _obj) => {
  const obj = { ...content(), [key]: _obj }
  setLocal("body", obj)
}

const clearLocal = (type) => {
  localStorage.removeItem(type)
}

const isStorage = (type) => {
  const _type = sessionStorage.getItem(type)
  // return false
  try {
    return JSON.parse(sessionStorage.getItem(type))
  } catch (e) {
    return false
  } finally {
  }
}

const setStorage = (type, value) => {
  sessionStorage.setItem(type, JSON.stringify(value))
}

const clearStorage = (type) => {
  sessionStorage.removeItem(type)
}

const getCurrentPages = (e) => {
  const findRoute = isLocal("treeData")?.find((f) => f.key === e)
  return findRoute?.children ? findRoute?.children : []
}

const urlSearch = (pathname, search) => {
  // const history = require("history").createBrowserHistory()
  // history.push({ pathname, search })
}

const msg = (type, msg, duration, maxCount) => {
  const { lang } = content()
  message.destroy();
  message.open({
    type,
    content: lang?.[msg] ?? msg,
    className: 'customMessage',
    duration,
    maxCount
  });
};

// const msg = (arr) => {
//   const { lang } = content()
//   message.destroy();
//   const p = { className: 'customMessage' }
//   const a = [...arr, p]
//   const _arr = a.map((el, i) => {
//     if (i === 1) {
//       return lang?.[el] ?? el
//     }else {
//       return el
//     }
//   })
//   message.open(_arr);
// };


// success, error, info, warning, open, destroy
// top topLeft topRight bottom bottomLeft bottomRight
const noti = (type, message, description, duration, placement, maxCount, onClick) => {
  notification.destroy();
  notification.open({
    type,
    message,
    description,
    className: 'customMessage',
    duration,
    placement,
    maxCount,
    // onClick
  });

  // if (click) {
  //   navigate("/dashboard")
  // }
};

const isJson = (str) => {
  // console.log(str)
  try {
    return JSON.parse(str) ? true : (typeof JSON.parse(str) === "boolean" ? true : false)
  } catch (e) {
    return false
  }
}

const copyToClipboard = (t, msg) => {
  try {
    var temp = document.createElement("textarea");
    document.body.appendChild(temp);
    temp.value = t;
    temp.select();
    document.execCommand("copy");
    document.body.removeChild(temp);
    // msg("success", defaultMsg, 3)
    message.open({
      type: "success",
      content: msg,
      className: 'customMessage',
      duration: 3,
    });
  } catch (e) {
    message.open({
      type: "error",
      content: e,
      className: 'customMessage',
      duration: 3,
    });
  } finally {

  }
}

const _children = (e, dragKey) => {
  let children = [];
  const pages = e.map(m => {
    if (m.children && m.children.length) {
      children = [...children, ...m.children];
    }
    return m;
  });

  return pages.concat(children.length ? _children(children) : children);
};

const destructArr = (e, dragKey) => {
  return _children(e, dragKey);
};

const findParent = (e, dragKey) => {
  let id = false
  for (var i = 0; i < e.length; i++) {
    if (e[i].children && e[i].children.length) {
      const _p = e[i].children.find((f) => f._id === dragKey)
      if (_p) {
        id = e[i]._id
      } else {
        findParent(e[i].children, dragKey)
      }
    }
  }
  // return e.map((el, i) => {
  //   if (el.children && el.children.length) {
  //     const _p = el.children.find((f) => f._id === dragKey)
  //     if (_p) {
  //       return el._id
  //     }else {
  //       findParent(el.children, dragKey)
  //     }
  //   }
  // });
  // e.forEach((el, i) => {
  //   if (el.children && el.children.length) {
  //     const _p = el.children.find((f) => f._id === dragKey)
  //     if (_p) {
  //       id = el._id
  //     }else {
  //       findParent(el.children, dragKey)
  //     }
  //   }
  // });
  if (id) {
    return id
  }
}

const prepareSub = (e, pages) => {
  const pagesN = pages.filter((f) => f?.parentId?.$ref)
  // console.log(pagesN)
  const page = pagesN.find((f) => f.route === e)
  const _pages = pagesN.filter((f) => f?.parentId?.$ref === page?.parentId?.$ref && f?.isPublished && !f?.isProtected)
  const reformat = _pages.map((el) => {
    // console.log(el)
    return ({
      key: el.route,
      id: el._id,
      // title: el.title,
      icon: el.icon ? renderIcon(el.icon, false, false, "no icon", "top") : renderIcon("Md2CursorDefaultClickOutline", false, false, "no icon", "top"),
      title: <Link to={el.route}>{el.pageName}</Link>,
      label: <Link to={el.route}>{el.pageName}</Link>
    })
  })
  return reformat
}

const prepareSubMenu = (e, pages) => {
  // console.log({
  //   e,
  //   pages
  // })
  const pagesN = pages.filter((f) => f?.parentId?.$ref)
  // console.log(pagesN)
  const page = pagesN.find((f) => f.route === e)
  const _pages = pagesN.filter((f) => f?.parentId?.$ref === page?.parentId?.$ref && f?.isPublished && !f?.isProtected)
  const reformat = _pages.map((el) => {
    // console.log(el)
    return ({
      key: el.route,
      id: el._id,
      // title: el.title,
      icon: el.icon ? renderIcon(el.icon, false, false, "no icon", "top") : renderIcon("Md2CursorDefaultClickOutline", false, false, "no icon", "top"),
      title: <Link to={el.route}>{el.pageName}</Link>,
      label: <Link to={el.route}>{el.pageName}</Link>
    })
  })
  return reformat
}

const removeDuplicateObj = (array, property) => {
  const uniqueIds = [];
  if (array && array.length > 0) {
    const unique = array.filter(el => {
      const isDuplicate = uniqueIds.includes(el[property]);
      if (!isDuplicate) {
        uniqueIds.push(el[property]);
        return true
      }
      return false
    })
    return unique;
  } else {
    return false
  }
}

const removeDuplicate = (arr) => {
  return [...new Set(arr.map((s) => JSON.stringify(s)))].map((s) => isJson(s) ? JSON.parse(s) : []);
}

const setFiltersCasd = (_filter, dataTable, _dataTable) => {
  // console.log(_filter)
  if (_filter && _filter.length > 0) {
    let tempDataTable = _dataTable
    _filter.forEach((el, i) => {
      tempDataTable = tempDataTable?.filter((f, i) => {
        const data = el.extra ? f[el.type][el.extra] === el.value.value : f[el.type] === el.value.value
        return data
      })
    });
    return tempDataTable
  } else {
    return _dataTable
  }
}

const sortNumAlpObj = (a, b, type) => {
  if (a && b && type) {
    var textA = a?.[type]?.toString().toUpperCase();
    var textB = b?.[type]?.toString().toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  }
}

const sortNumAlp = (arr) => {
  if (arr && arr.length > 0) {
    return arr.sort((a, b) => {
      var textA = a?.label?.toString().toUpperCase();
      var textB = b?.label?.toString().toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
}

const sortNumArr = (arr) => {
  if (arr && arr.length > 0) {
    return arr.sort((a, b) => {
      var textA = a.toUpperCase();
      var textB = b.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
}

const windowSize = (screenWidth, screenHeight, w, h) => {
  if (screenWidth < 500) {
    const col = 1
    return col
    // return { col, width: (screenWidth / col)}
  } else if (screenWidth >= 500 && screenWidth <= 1000) {
    const col = 3
    return col
    // return { col, width: (screenWidth / col)}
  } else if (screenWidth > 1000 && screenWidth <= 1600) {
    const col = 6
    return col
    // return { col, width: (screenWidth / col)}
  } else {
    const col = 12
    return col
    // return { col, width: (screenWidth / col)}
  }
}

const subDate = (days) => {
  const dateOffset = (24 * 60 * 60 * 1000) * days
  const myDate = new Date();
  return myDate.setTime(myDate.getTime() - dateOffset);
}

const jsonPrettify = (json) => {
  if (typeof json === 'object' && json !== null) {
    const pretty = JSON.stringify(json, undefined, 4);
    return pretty;
  }
  try {
    const obj = JSON.parse(json);
    return jsonPrettify(obj);
  } catch (e) {
    return json;
  }
};

const setNewPages = (newLayout, pageData) => {
  // console.log(newLayout, pageData)
  let widgets = []
  const { pages, token, user, licence } = content()
  const _pageData = isLocal("pageData")
  _pageData.widgets.forEach((el, i) => {
    widgets.push({ ...el, children: newLayout })
  });
  const filter = pages.filter((f) => f._id !== pageData._id)
  const updatePage = { ...pageData, widgets }
  const mergedPages = [{ ...updatePage }, ...filter]

  const _content = { ...content(), pages: mergedPages }
  setLocal("body", _content)
  return widgets
}

const devMode = (props, d) => {
  const { systemAdminGroups } = content()
  systemAdminGroups && console.log({ props, d })
}

const findObj = (e) => {
  if (e && e.length > 0) {
    let obj = {}
    e.forEach((el, i) => {
      obj[el.name] = isJson(el.obj) ? JSON.parse(el.obj) : el.obj
    });
    return obj
  }
}

const reformat = (arr) => {
  return arr.map((el, i) => ({ ...el, key: i + 1 }))
}

const findLabel = (e) => {
  // console.log(e)
  const keys = ["label", "name", "group", "model"]
  // const _e = e.filter((f) => keys.find((fi) => f[fi]))
  const _e = keys.find((fi) => e[fi])
  if (_e) {
    return _e
  }
}


const urlPrepare = (arr) => {

}

const checkServer = () => {
  return querySelectValidation({
    url: "/api/checknode"
  }).then(el => {
    if (typeof el === 'boolean' && el) {
      return true
    } else {
      msg("error", "Error please contact administrator - code - 007", 10)
    }
  })
}


const recursiveTreeBuild = (data, parent, arr) => {
  // let _child = data.filter((p) => p?.parentId?.$ref === (parent._id || parent.prevId));
  let _child = data.filter((p) => p?.parentId?.$ref === parent._id);
  let child = [..._child]
  if (child.length > 0) {
    if (!child.children) {
      arr.children = [];
    }
    for (var i = 0; i < child.length; i++) {
      arr.children.push({ ...child[i] });
      recursiveTreeBuild(data, child[i], arr.children[i])
    }
    return arr.children
  }
}

const createTree = (e) => {
  const parent = e.filter((el) => !el.parentId)
  return recursiveTreeBuild(e, parent, [])
}

const createLocationAssetTree = async (e, filterAssetsTree) => {
  const stepGraph = await e.map(el => {
    let assetsOnLocation = []
    filterAssetsTree.forEach((asset, i) => {
      // console.log(asset)
      if (asset.locationId === el.locationId) {
        assetsOnLocation.push({
          ...asset,
          key: asset._id,
          title: asset.asset_name,
          label: asset.asset_name,
          value: asset._id,
          asset_name: asset.asset_name,
          locationId: asset.locationId,
          _id: asset._id,
        })
      }
    })
    return ({ ...el, children: assetsOnLocation })
    // return (el)
  })
}

// const renderIconV3 = (icon, size, color) => {
//   const Component = icons[icons[icon] ? icon : "MdOutlineDisabledByDefault"]
//   return  <Component style={{ color: color, fontSize: size }} />
// }

const isEqual = (obj1, obj2) => {

  /**
  * More accurately check the type of a JavaScript object
  * @param  {Object} obj The object
  * @return {String}     The object type
  */
  function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  }

  function areArraysEqual() {
    // Check length
    if (obj1.length !== obj2.length) return false;
    // Check each item in the array
    for (let i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) return false;
    }
    // If no errors, return true
    return true;
  }

  function areObjectsEqual() {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
    // Check each item in the object
    for (let key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        if (!isEqual(obj1[key], obj2[key])) return false;
      }
    }
    // If no errors, return true
    return true;
  }

  function areFunctionsEqual() {
    return obj1.toString() === obj2.toString();
  }

  function arePrimativesEqual() {
    return obj1 === obj2;
  }

  // Get the object type
  let type = getType(obj1);

  // If the two items are not the same type, return false
  if (type !== getType(obj2)) return false;

  // Compare based on type
  if (type === 'array') return areArraysEqual();
  if (type === 'object') return areObjectsEqual();
  if (type === 'function') return areFunctionsEqual();
  return arePrimativesEqual();

}

const isEmpty = (obj) => {
  return Object.keys(obj ? obj : {}).length === 0;
}

const remap = (arr) => {
  if (Array.isArray(arr)) {
    return arr.map((el, i) => ({ ...el, key: i + 1 }))
  } else {
    return arr
  }
}

const openMessage = (b, confirm) => {
  const duration = (b?.duration * 1000)
  const key = 'updatable'
  message.open({
    key,
    type: 'loading',
    content: 'Please wait saving...',
  });

  setTimeout(() => {
    message.open({
      key,
      type: 'success',
      content: 'saved',
      duration: (duration / 1000),
    });
    confirm(true)
  }, duration);
};

const convertSize = (bytes, units) => {
  switch (units) {
    case "KB": return (bytes / 1000);
    case "MB": return (bytes / (1024 * 1024)).toFixed(2);
    case "GB": return (bytes / (1024 * 1024 * 1024)).toFixed(2);
    case "TB": return (bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2);
    default: return bytes;
  }
}


// const antdIcons = async() => {
//   return {
//     ExclamationCircleOutlined: await import("@ant-design/icons/ExclamationCircleOutlined"),
//     HomeOutlined: await import("@ant-design/icons/HomeOutlined"),
//   }
// }
const renderIcon = (icon, fontSize, color) => {
  const Component = icons[icons[icon] ? icon : "QuestionCircleOutlined"]
  return <Component style={{ color, fontSize }} />
}

const iconsRender = (el) => {
  return <span>{renderIcon(el, 20, "", false, false)} {el}</span>
}

const allIcons = async () => {
  // const iconsA = await antdIcons()
  // const ic = Object.keys(iconsA)
  const ic = Object.keys(icons)
  // console.log(ic)
  let _icons = []
  for (var i = 0; i < ic.length; i++) {
    // _icons.push({ key: i + 1, label: ic[i], value: ic[i], })
    // _icons.push({ key: i + 1, label: ic[i], value: iconsA?.[ic[i]]?.default, })
    _icons.push({ key: i + 1, label: iconsRender(ic[i]), value: ic[i], })
  }
  // console.log(_icons)
  return _icons
}

const setTheme = (_theme) => {
  if (!_theme || _theme === "light") {
    return {
      colorBgContainer: "rgb(255, 255, 255)",
      colorText: "rgb(0, 0, 0)",
      theme: "light"
    }
  } else if (_theme === "dark") {
    return {
      colorBgContainer: "#001529",
      colorText: "rgb(255, 255, 255)",
      theme: "dark"
    }
  }
}

const getObjectDifference = (obj1, obj2) => {
  obj1 = obj1 ? obj1 : {}
  obj2 = obj2 ? obj2 : {}

  const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  const diff = {};

  // keys.forEach(key => {
  //     if (obj1[key] !== obj2[key]) {
  //         diff[key] = {
  //             // oldValue: obj1[key],
  //             newValue: obj2[key]
  //         };
  //     }
  // });

  keys.forEach(key => {
    if (obj2[key]) {
      if (obj1[key] !== obj2[key]) {
        diff[key] = obj2[key];
      } else {
        // console.log(key)
      }
    }
  });

  return diff;
}
// const confirm = (e) => {
//   props?.operationN({ activeKey: "3", props })
//   msg("success", (lang?.["saved"] ?? "saved"), 2)
// }
// openMessage({ duration: 2 }, confirm)

const resizeImage = (base64Str) => {
  var img = new Image();
  img.src = base64Str;
  var canvas = document.createElement('canvas');
  var MAX_WIDTH = 40;
  var MAX_HEIGHT = 40;
  var width = img.width;
  var height = img.height;

  if (width > height) {
    if (width > MAX_WIDTH) {
      height *= MAX_WIDTH / width;
      width = MAX_WIDTH;
    }
  } else {
    if (height > MAX_HEIGHT) {
      width *= MAX_HEIGHT / height;
      height = MAX_HEIGHT;
    }
  }
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL();
}

const mergeArrays = (arr1, arr2, key) => {
  let mergedArray = arr1.map(item => {
    let match = arr2.find(i => i[key] === item[key]);
    return match ? { ...item, ...match } : item;
  });
  return mergedArray;
}

const mergeArraysIndex = (arr1, arr2, key) => {
  if (Array.isArray(arr1)) {
    const merged = [...arr1];
    arr2.forEach(item2 => {
      const index = merged.findIndex(item1 => item1[key] === item2[key]);
      if (index === -1) {
        merged.push(item2);
      } else {
        merged[index] = { ...merged[index], ...item2 };
      }
    });
    return merged;
  }
};
const roundNum = (number, dec) => {
  // console.log(number, dec)
  if (number % 1 !== 0) {
    let rounded = Math.round(number * 1000) / 1000;
    return Number(rounded.toFixed(dec ? dec : 2))
  } else {
    return number
  }
}

const cleanObj = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
}

const removeKeys = (obj, excludeKeys) => {
  let newObj = { ...obj }
  excludeKeys.forEach(key => {
    delete newObj[key];
  });
  return newObj;
}

const codeteled = async (e) => {
  const d = await allinPut("codeteled", e)
  return d
}

const isTerminal = () => {
  const strings = ["terminalMode"]
  const pathname = window.location.pathname
  const searchString = strings.find((f) => pathname.includes(f))
  return searchString
}

const reRouting = (pathname) => {
  // const { pages } = content()
  // const page = pages.find((f) => f?.route === pathname)
  // console.log(pathname, page)
}

const replaceObject = (newObject, array) => {
  return array.map(obj =>
    obj.key === newObject.key ? newObject : obj
  );
}

const userPermissions = (pathname) => {
  const { user, pages } = content()
  try {
    const page = pages.find((f) => f.route === pathname)
    if (user?.permissions?.find((f) => f === page?._id)) {
      return true
    }
    return false
  } catch (e) {
    return false
  } finally { }
}

const userPermissionsRWD = (pathname, pageName, pageId) => {
  const { _pages } = content()
  try {
    const page = _pages.find((f) => f.route === pathname || f?.pageName === pageName || f?._id === pageId)
    return page?._id
  } catch (e) {
    return false
  } finally { }
}

const prepareId = () => {
  let id = false
  const urlSearch = destructUrl(window.location.search)
  if (urlSearch?.pid) {
    return { type: urlSearch?.type, id: urlSearch?.pid }
  }
  if (!urlSearch?.pid && urlSearch?.id) {
    return { type: urlSearch?.type, id: urlSearch?.id }
  }
}

const isMobile = () => {
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent);
};

const checkMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  return mobileRegex.test(userAgent.toLowerCase())
};

const isValidValue = (value) => {
  return (
    (typeof value === "string" && value.length > 0) ||
    (typeof value === "object" && value !== null)
  );
};

const findInvalidKeys = (obj, keys) => {
  return keys.filter(
    (key) => !obj.hasOwnProperty(key) || !isValidValue(obj[key])
  );
};

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

const checkString = (input) => {
  if (!isNaN(input) && input.trim() !== "") {
    return "number";
  } else {
    return "string";
  }
}

// const sorter = (a, b, col) => {
//   const dataIndex = checkString(a?.[col?.dataIndex])
//   if (dataIndex === "number") {
//     return Number(b?.[col?.dataIndex]) - Number(a?.[col?.dataIndex])
//   }
//   if (dataIndex === "string") {
//     return a?.[col?.dataIndex]?.length - b?.[col?.dataIndex]?.length
//   }
// }

const sorter = (a, b, col) => {
  if (a?.[col?.dataIndex] < b?.[col?.dataIndex]) return -1
  if (a?.[col?.dataIndex] > b?.[col?.dataIndex]) return 1
  return 0
}

const fetchDataOwnership = async (obj) => {
  const r = await getFetch("70874aa5-d2c1-4e55-b762-305ef29b6c15", obj)
  return r
}
const handleOwnershipChangeStatus = async(type, id, ownershipId) => {
  // console.log({e, i, col, record})
  const r = await allinPut("updateOwnershipDocument", { type, id, ownershipId })
  if (r) {
    msg("success", "Novo lastništvo je odobreno in shranjeno", 5)
  }
}

const fetchDataWorkflow = async (obj) => {
  const r = await allinOne("getStatusWorkflow", obj)
  const steps = (Array.isArray(r?.steps)) ? r?.steps.map((el) => ({ ...el, label: el?.statusLabel, value: el?.id })) : []
  return steps
}
const handleSelectChangeStatus = async(type, id, statusId, statusLabel) => {
  const r = await allinPut("updateStatusDocument", { type, id, statusId, statusLabel })
  if (r) {
    // setTemp({ statusId: i?.id, statusLabel: i?.label })
    msg("success", "Status " + statusLabel + " odobren in shranjen", 5)
  }
}

const handleSelecFazeChangeStatus = async(type, id, statusId, statusLabel) => {
  alert("not yet")
  // const r = await allinPut("updateStatusDocument", { type, id, statusId, statusLabel })
  // if (r) {
  //   // setTemp({ statusId: i?.id, statusLabel: i?.label })
  //   msg("success", "Status " + statusLabel + " odobren in shranjen", 5)
  // }
}

const getRandomColor = () => {
    return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
}

const hasValidObject = (arr) => {
  if (Array.isArray(arr)) {
    return arr.some(obj =>
      obj && typeof obj === 'object' &&
      Object.values(obj).some(value =>
        (typeof value === 'string' && value.length > 0) ||
        (typeof value !== 'string' && value !== null && value !== undefined)
      )
    );
  }
  return false
}

const isWhiteOrBright = (color) => {
    const r = parseInt(color.slice(1, 3), 16); // Red component
    const g = parseInt(color.slice(3, 5), 16); // Green component
    const b = parseInt(color.slice(5, 7), 16); // Blue component
    const brightness = (r * 0.299) + (g * 0.587) + (b * 0.114); // Luminance formula
    return brightness > 200;
}

const ifInteger = (number) => {
  return number % 1 !== 0
}

const replaceDot = (number) => {
  return parseFloat(number).toFixed(2).replace(".", ",")
}

const hasDecimal = (num) => {
  return num % 1 !== 0; // Returns true if the number has a decimal part
}

const hasDecimalPlaces = (num, place) => {
  place = place ? place : 2
  const decimalStr = num.toString().split(".")[1]
  let length = (!decimalStr?.length || decimalStr?.length > place) ? place : decimalStr?.length
  return length ?? 0
}


const toFixedDecimal = (number, place, showDecimal) => {
  // console.log([number, place, showDecimal, hasDecimalPlaces(number, place)])
  // console.log(hasDecimalPlaces(number, place))
  number = Number(number)
  place = place ? place : 2
  if (typeof number === "number") {
    if (showDecimal) {
      return number.toFixed(hasDecimalPlaces(number, place))
    }else {
      if (hasDecimal(number)) {
        return number.toFixed(hasDecimalPlaces(number, place))
      }
      return number
    }
  }
  return 0
}

const fetchData = async ({ location }) => {
  const params = new URLSearchParams(location.search);
  const id = params.get('id');
  const type = params.get('type');
  if (id && type) {
    try {
      const urlSearch = { id, type };
      const result = await allinOne("getDocumentById", urlSearch);
      if (result) {
        return result;
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {}
  } else {
    return null
  }
};

const searchObjects = (array, searchTerm) =>{
  const lowerTerm = searchTerm.toLowerCase();
  return array.filter(obj =>
    Object.values(obj).some(val =>
      String(val).toLowerCase().includes(lowerTerm)
    )
  );
}

export {
  cleanObj, protectedRoute, socket, content, localStor, renderIcon, msg, noti, recursiveTreeBuild, checkServer, hasValidObject, toFixedDecimal,
  langPrepare, findTimePicker, destructUrl, urlSearch, jsonPrettify, urlPrepare, prepareSubMenu, userPermissionsRWD, mergeArraysIndex, checkMobile,
  toast, isLocal, setLocal, clearLocal, getCurrentPages, _logout, reformat, mergeArrays, userPermissions, fetchDataOwnership, replaceDot,
  isJson, copyToClipboard, destructArr, findParent, prepareSub, allIcons, roundNum, isTerminal, prepareId, handleOwnershipChangeStatus, updateContentLocal,
  createTree, removeDuplicateObj, removeDuplicate, setFiltersCasd, findLabel, codeteled, replaceObject, checkString, sorter, isWhiteOrBright,
  sortNumAlpObj, windowSize, sortNumAlp, sortNumArr, subDate, urlString, removeKeys, reRouting, findInvalidKeys, getRandomColor, ifInteger, searchObjects,
  setNewPages, isStorage, setStorage, clearStorage, devMode, findObj, createLocationAssetTree, validateEmail, handleSelecFazeChangeStatus, fetchData,
  isEqual, isEmpty, remap, openMessage, convertSize, setTheme, getObjectDifference, resizeImage, isMobile, fetchDataWorkflow, handleSelectChangeStatus
}
